module.exports = __webpack_public_path__ + "img/gritsaev.f51e73f7.jpg";